const ValidarPlanDeVentaHandler = (event) => {
    let errorFlow = `ERRORVALIDARPLAN`;
    console.log('🚀 ~ file: ValidarPlanDeVentaHandler.js ~ line 3 ~ response: ', event.data.response);

    if (!event.data.response) {
        return errorFlow;
    }

    switch (true) {
        case event.data.response.esPlanCompatible:
            return 'OBTENERCAMPANIA';
        case event.data.response.tieneDeuda:
            return 'PAGOPENDIENTE';
        case event.data.response.esSuscriptor:
            return 'YASOSSUSCRIPTOR';
        case event.data.response.planInsuficiente:
            return 'REDIRECTPAYWALL';
        case event.data.response.esDNIValido:
            return 'VALIDARSUSCRIPCIONES';
        case event.data.response.errorDNIInvalido:
            return 'DOCUMENTOINVALIDO';
        case event.data.response.errorDNIExiste:
            return 'DATOSPERSONALES';
        default:
            return errorFlow;
    }
};

export default ValidarPlanDeVentaHandler;
